// extracted by mini-css-extract-plugin
module.exports = {"infoCaption":"log_infoCaption_iG2VS","infoValue":"log_infoValue_2CzPF"};